export default {
    methods: {
        changePage(page) {
            this.page = page;
            this.loadTable();
        },

        closePopup() {
            this.item = null;
        },

        handleOpen(itemId, evt) {
            if (
                evt.target.classList.length === 0 ||
                !['checkbox', 'active', 'inactive', 'download-icon'].some((x) => evt.target.classList.contains(x))
            ) {
                this.openForm(itemId);
            }
        },

        handleSelected(itemId) {
            if (this.selected.indexOf(itemId) !== -1) {
                this.selected.splice(this.selected.indexOf(itemId), 1);
            } else {
                this.selected.push(itemId);
            }
        },

        setPage(page) {
            this.page = page;
        },

        updateFieldValue(field, value) {
            let item = { ...this.item };
            item[field] = value;
            this.item = item;
        },
    },
};
